import React from "react";

type Props = {
    onClose: () => void;
};

const MoreSignsMenu = (props: Props) => {
    return (
        <div className="more-signs-menu" style={{display: "flex"}}>
            <div className="no-num-box">
                <h2>Check out all the signs TacBoard has to offer:</h2>
                <a href="wedding-sign-shop" className="nav-tb-sign">TacBoard Phone Number Signs</a>
                <a href="wedding-hashtag-sign-shop" className="nav-hash-sign">Wedding Hashtag Signs</a>
                <div className="close-menu" onClick={props.onClose}>close</div>
            </div>
        </div>
    );
}

export default MoreSignsMenu;
